import React from 'react'
import Drawer from '@material-ui/core/Drawer'
import Button from '@material-ui/core/Button'
import ClearIcon from '@material-ui/icons/Clear'
import { Link } from "react-router-dom"
import Directions from "../Shared/Directions"
import Reservations from "../Shared/Reservations"
const classes = require('./Header.module.scss')

function TemporaryDrawer() {
  const [state, setState] = React.useState({
    left: false,
  })

  const toggleDrawer = (side, open) => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }

    setState({ ...state, [side]: open })
  }

  const sideList = side => (
    <div
      className={[classes.list, classes.SideNavList].join(' ')}
      role="presentation"
      onClick={toggleDrawer(side, false)}
      onKeyDown={toggleDrawer(side, false)}
    >
      <div className={classes.closeIcon}><ClearIcon /></div>
      <ul className={classes.SideNav}>
        <div className={classes.quickLinks}>
          {/* <ul className={classes.devList}> */}
            <p className={classes.cat}>Quick Links</p>
            <li className={[classes.navItem, classes.quick].join(' ')}><Reservations /></li>
            <li className={[classes.navItem, classes.quick].join(' ')}><a href="https://order.toasttab.com/online/mile-marker-158" target="_blank" rel="noopener noreferrer" className={[classes.togo, classes.takeout].join(' ')}>Order Takeout</a></li>
            <li className={[classes.navItem, classes.quick].join(' ')}><a href="https://www.doordash.com/store/mile-marker-158-dockside-orange-beach-27866264/114629747" target="_blank" rel="noopener noreferrer" className={[classes.togo, classes.deliv].join(' ')}>Door Dash Delivery</a></li>
          {/* </ul> */}
        </div>

        <li className={classes.navItem}><Link to="/">Home</Link></li>
        <li className={classes.navItem}><Link to="/happy-hour">Specials</Link></li>
        <li className={classes.navItem}><Link to="/daily-menu">Daily Menu</Link></li>
        <li className={classes.navItem}><Link to="/brunch-menu">Brunch Menu</Link></li>
        <li className={classes.navItem}><Link to="/kids-menu">Kids Menu</Link></li>
        <hr/>
        {/* <li className={[classes.navItem, classes.emph].join(' ')}><Link to="/wine-dinner">Wine Dinner</Link></li> */}
        <li className={classes.navItem}><Link to="/lasagna-night">Lasagna Night</Link></li>
        <hr/>
        <li className={classes.navItem}><a href="https://wharfcateringgroup.com/" target="_blank" rel="noopener noreferrer">Catering</a></li>
        {/* <li className={classes.navItem}><Link to="/entertainment">Entertainment</Link></li> */}
        <li className={classes.navItem}><Link to="/contact">Contact</Link></li>
        <li className={[classes.navItem, classes.XXniBtn].join(' ')}><Directions /></li>
      </ul>
    </div>
  )

  return (
    <div className={classes.NavDrawer}>
      <Button onClick={toggleDrawer('left', true)}>
        <span aria-label="Mile Marker 158 Dockside Navigation Link" uk-icon="icon: menu" className={classes.mobileNavBtn}></span>
      </Button>
     
      <Drawer anchor="left" open={state.left} onClose={toggleDrawer('left', false)} className={classes.cNavDrawer}>
        {sideList('left')}
      </Drawer>
    </div>
  )
}

export default TemporaryDrawer